import PageHero from '../components/PageHero';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../config/seo';
import { heroImages } from '../assets/menuImages';
import OptimizedImage from '../components/OptimizedImage';
import { LeafIcon, ChefHatIcon, ClockIcon, HeartIcon } from '../components/Icons';

const values = [
  { icon: LeafIcon, title: 'Fraîcheur', desc: 'Ingrédients sélectionnés chaque jour' },
  { icon: ChefHatIcon, title: 'Générosité', desc: 'Des portions copieuses et savoureuses' },
  { icon: ClockIcon, title: 'Rapidité', desc: 'Livraison et service efficaces' },
  { icon: HeartIcon, title: 'Passion', desc: 'Préparés avec amour et expertise' },
];

const team = [
  { name: 'Chef Principal', role: 'Cuisine & Innovation', initial: 'C' },
  { name: 'Gérant', role: 'Direction & Qualité', initial: 'G', dark: true },
  { name: 'Service client', role: 'Relation & Livraison', initial: 'S' },
];

function About() {
  return (
    <div className="inner-page about-page">
      <SEO {...PAGE_SEO.about} />
      <PageHero
        tag="Notre histoire"
        title="Qui sommes-nous ?"
        subtitle="Du goût, du plaisir, à chaque bouchée — à Yaoundé"
      />

      <section className="page-content page-content-cream">
        <div className="about-grid">
          <div className="about-image">
            <OptimizedImage
              image={heroImages.woman}
              alt="Cliente savourant un burger DoWhile Food"
              loading="lazy"
            />
          </div>
          <div className="about-text-block">
            <h2 className="inner-section-title">Notre passion pour la food</h2>
            <p className="about-text">
              DoWhile Food est née d'une passion simple : créer des plats savoureux,
              généreux et accessibles. Nous préparons chaque burger, chaque taco et
              chaque crêpe avec des ingrédients frais et une attention particulière au goût.
            </p>
            <p className="about-text">
              Notre mission : vous offrir une expérience culinaire unique à Yaoundé,
              du plaisir à chaque bouchée.
            </p>
            <div className="values-grid">
              {values.map(({ icon: Icon, title, desc }) => (
                <div key={title} className="value-box">
                  <div className="value-icon">
                    <Icon size={18} />
                  </div>
                  <div>
                    <h4 className="value-title">{title}</h4>
                    <p className="value-desc">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="section-heading">
          <h2 className="section-title">Notre équipe</h2>
          <p className="section-subtitle">Des passionnés à votre service</p>
        </div>
        <div className="team-grid">
          {team.map(({ name, role, initial, dark }) => (
            <article key={name} className="team-card">
              <div className={`team-avatar ${dark ? 'team-avatar-dark' : ''}`}>{initial}</div>
              <h3 className="team-name">{name}</h3>
              <p className="team-role">{role}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;
